// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"abd6f124","338":"2a1f4a09","576":"25f4949a","753":"7dd71b3d","775":"dce0738d","823":"db5452b4","880":"c455e4a3","990":"b8e283de"}[chunkId] + ".js";
};